import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle, Package } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CheckoutSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Clear cart
    localStorage.removeItem('cart');

    // Fetch session details
    if (sessionId) {
      axios.get(`${API}/checkout/session/${sessionId}`)
        .then(response => {
          setSession(response.data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching session:', error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            <button onClick={() => { window.scrollTo(0, 0); navigate('/'); }} className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_elite-lighting/artifacts/27f7yllt_WhatsApp%20Image%202025-10-18%20at%2008.58.35.jpeg" 
                alt="ONYX Home Solutions" 
                className="h-12 lg:h-16 w-auto object-contain"
                style={{ background: 'transparent' }}
              />
            </button>
          </div>
        </div>
      </nav>

      {/* Success Content */}
      <div className="pt-32 pb-20 px-4 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-white rounded-3xl p-12 shadow-xl">
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}>
              <CheckCircle className="w-12 h-12 text-white" />
            </div>
            
            <h1 className="text-4xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
              Order Confirmed!
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              Thank you for your purchase. Your order has been successfully placed.
            </p>

            {!loading && session && (
              <div className="bg-gray-50 rounded-2xl p-6 mb-8 text-left">
                <div className="flex items-start gap-4">
                  <Package className="w-6 h-6 flex-shrink-0 mt-1" style={{ color: '#8B6F47' }} />
                  <div className="flex-1">
                    <h3 className="font-bold mb-2" style={{ color: '#1d1d1f' }}>Order Details</h3>
                    <p className="text-sm text-gray-600 mb-2">Order ID: {session.id}</p>
                    <p className="text-sm text-gray-600 mb-2">Confirmation sent to: {session.customer_email}</p>
                    <p className="text-sm text-gray-600">Total paid: ${(session.amount_total / 100).toFixed(2)}</p>
                  </div>
                </div>
              </div>
            )}

            <div className="bg-blue-50 rounded-2xl p-6 mb-8">
              <p className="text-sm text-gray-700 leading-relaxed">
                <strong className="text-blue-900">What's Next?</strong><br />
                You'll receive an order confirmation email shortly. We'll notify you when your order ships with tracking information.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => { window.scrollTo(0, 0); navigate('/products'); }}
                className="text-white px-8 py-4 rounded-full text-base font-medium"
                style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}
              >
                Continue Shopping
              </Button>
              <Button 
                onClick={() => { window.scrollTo(0, 0); navigate('/'); }}
                variant="outline"
                className="px-8 py-4 rounded-full text-base font-medium border-2"
                style={{ borderColor: '#8B6F47', color: '#8B6F47' }}
              >
                Back to Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
